import React, { useState, useEffect, useRef } from 'react';
import './GuestInfoModal.css';
import { API_BASE_URL } from '../config';
import { useAuth } from '../contexts/AuthContext';

const GuestInfoModal = ({ onSubmit }) => {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState('');
  const nameRef = useRef(null);
  const { authFetch } = useAuth();

  useEffect(() => {
    // Autofocus on "Full Name" input when modal opens
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate name
    if (!name.trim()) {
      setError('Please enter your full name.');
      return;
    }

    // Validate mobile number
    const mobileRegex = /^[6789]\d{9}$/;
    if (!mobileRegex.test(mobile)) {
      setError("Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.");
      return;
    }

    const guestId = localStorage.getItem("guestId");
    if (!guestId) {
      setError("Guest ID not found. Please refresh the page.");
      return;
    }

    try {
      const res = await authFetch(`${API_BASE_URL}/api/guest/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ guest_id: guestId, name, mobile })
      });

      const data = await res.json();
      console.log("✅ Guest registered/updated:", data);

      localStorage.setItem("guestName", name);
      localStorage.setItem("guestMobile", mobile);

      if (onSubmit) {
        onSubmit({ guest_id: guestId, name, mobile });
      }
    } catch (err) {
      console.error("❌ Error registering guest:", err);
      setError(err.message || "An error occurred while registering.");
    }
  };

  return (
    <div className="guest-modal">
      <div className="guest-modal-content">
        <h2>RealtySeek.ai Welcomes You</h2>
        <p className="subheading">Please provide your Name &amp; Mobile to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            ref={nameRef}
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="tel"
            placeholder="Mobile Number (10-Digit)"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            pattern="^[6789]\d{9}$"
            title="Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9"
            required
          />
          {error && <p className="error-message">{error}</p>}
          <button type="submit">Submit</button>
        </form>
        <p className="disclaimer">We respect your privacy. Your info is secure.</p>
      </div>
    </div>
  );
};

export default GuestInfoModal;
